// extracted by mini-css-extract-plugin
export default {"wrapper":"auto-complete_wrapper__Hf7cW"};